<div class="breadcrumb d-inline-flex small bluey-grey p-0">
    <span *ngFor="let item of breadcrumb">{{item}}</span>
</div>
